import axios from "axios";
import Vue from "vue";
import VueAxios from "vue-axios";
const baseURL = `${process.env.VUE_APP_BASE_URL}`;
axios.defaults.baseURL = baseURL;
Vue.use(VueAxios, axios);
